module.exports = __webpack_public_path__ + "media/images/ADC_Logo_FC_horizontal-50bacc03805618af95f307a9c520aca9.png";